
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/which-gemini-model-is-best-for-chat",
      function () {
        return require("private-next-pages/which-gemini-model-is-best-for-chat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/which-gemini-model-is-best-for-chat"])
      });
    }
  